import React from 'react';
import classnames from 'classnames';

import style from './Logo.module.less';

interface LogoProps {
  monochrome?: boolean;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className, monochrome }) => (
  <div className={classnames(style.logo, className)}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 275 353"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2
      }}
    >
      <g transform="matrix(1,0,0,1,-160,-244)">
        <rect id="Page-1" x="0" y="0" width="595.276" height="841.89" style={{ fill: 'none' }} />
        <g id="Page-11">
          <g id="Warstwa-1">
            <g transform="matrix(1,0,0,1,405.198,476.103)">
              <path
                d="M0,-191.876C-30.56,-180.158 -74.56,-164.658 -106.228,-155.256C-88.06,-150.658 -65.073,-144.744 -48.55,-139.233L-56.245,6.317C-42.599,0.414 -28.784,-5.104 -14.8,-10.236C-9.863,-65.448 -4.929,-136.661 0,-191.876M29.44,-231.158L7.176,1.874C-22.733,12.336 -51.883,24.836 -80.068,39.282C-79.902,34.209 -79.736,29.168 -79.57,24.125C-73.482,20.738 -67.426,17.474 -61.43,14.36C-67.476,13.1 -73.331,11.942 -79.132,10.849C-77.627,-34.687 -76.122,-79.333 -74.617,-125.334C-104.06,-133.658 -158.56,-147.158 -176.06,-150.658C-163.06,-153.658 -28.06,-205.658 29.44,-231.158M-121.466,-65.256C-110.389,-62.745 -102.948,-60.161 -91.931,-57.506L-92.341,-40.999C-103.183,-43.45 -110.438,-45.827 -121.318,-48.13L-121.466,-65.256Z"
                style={{
                  fill: monochrome ? 'rgb(255,255,255)' : 'rgb(222,81,150)',
                  fillRule: 'nonzero'
                }}
              />
            </g>
            <g transform="matrix(1,0,0,1,187.096,542.389)">
              <path
                d="M0,-191.57C14.542,-198.444 28.042,-204.944 42.464,-211.998C45.752,-156.804 49.039,-101.614 52.327,-46.429C66.691,-44.726 81.038,-42.93 95.368,-41.041C68.725,-24.813 43.17,-6.877 18.866,12.653C12.59,-55.411 6.301,-123.485 0,-191.57M147.787,-47.226C150.76,-48.825 153.724,-50.396 156.672,-51.927C155.096,-52.255 153.536,-52.575 151.984,-52.891C150.937,-53.103 149.898,-53.31 148.86,-53.518C148.417,-53.606 147.97,-53.696 147.528,-53.784C146.197,-54.047 144.872,-54.307 143.552,-54.562C143.448,-54.582 140.393,-55.169 138.975,-55.436C118.422,-59.307 98.588,-62.307 73.674,-65.689C71.707,-114.169 69.74,-162.638 67.772,-211.105C56.807,-213.731 47.573,-215.838 42.042,-216.944C44.974,-217.621 54.127,-220.796 67.184,-225.592C66.907,-232.436 66.629,-239.282 66.351,-246.126C35.042,-231.944 5.542,-217.944 -26.458,-204.12C-16.895,-117.893 -7.332,-31.667 2.232,54.556C43.668,16.55 97.201,-20.004 147.568,-47.109C147.641,-47.148 147.714,-47.187 147.787,-47.226"
                style={{
                  fill: monochrome ? 'rgb(255,255,255)' : 'rgb(116,31,187)',
                  fillRule: 'nonzero'
                }}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
);
